// components/RadioGroup.tsx
export interface Option {
  label: string;
  value: string | number;
}

interface RadioGroupProps {
  question: string;
  options: Option[];
  name: string;
  required?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const RadioGroup: React.FC<RadioGroupProps> = ({ question, options, name, required, onChange }) => {
  return (
    <div className="space-y-4">
      <p className="mb-4 text-sm font-medium text-ink">
        {required && (
          <span aria-hidden className="mr-1 text-xs text-muted">
            *
          </span>
        )}
        {question}
      </p>

      <div>
        {options.map((option, index) => (
          <label
            key={index}
            className="group flex cursor-pointer items-center border-b border-hairline py-3 transition-colors duration-200 hover:border-accent"
          >
            <input
              type="radio"
              name={name}
              value={option.value}
              required={required}
              onChange={onChange}
              className="sr-only peer"
            />

            {/* Custom radio button */}
            <span className="flex h-4 w-4 items-center justify-center rounded-full border border-muted/60 transition-colors duration-200 peer-checked:border-accent peer-focus-visible:border-accent">
              <span className="h-2 w-2 rounded-full bg-accent opacity-0 transition-opacity duration-200 peer-checked:opacity-100" />
            </span>

            <span className="ml-4 text-base font-light text-ink transition-colors duration-200 group-hover:text-accent">
              {option.label}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
};
